import { createSelector } from "@ngrx/store";
import { AppState } from "src/app/core/models/app-state.models";
import { Session } from "src/app/core/models/session.models";

export const selectAppStatus = createSelector(
    (state: AppState) => state.session,
    (session: Session) => session
);


export const selectAppLoader = createSelector(
    selectAppStatus,
    (session) => session.loader
);

export const selectAuthToken = createSelector(
    selectAppStatus,
    (session) => session.authToken
);

export const selectLoginStatus = createSelector(
    selectAppStatus,
    (session) => session.isLogged
);

export const selectIsMobile = createSelector(
    selectAppStatus,
    session => session.isMobile
)

export const selectBlockLogin = createSelector(
    selectAppStatus,
    (session) => session.blockLogin
);